const notifyBeforeTypes = {
  HOUR: 'HOUR',
  DAY: 'DAY',
  WEEK: 'WEEK'
};

export default notifyBeforeTypes;